/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { connect } from "react-redux";

// project imports
import store from "features/store";
import Datatable from "shared/datatable";
import { MyAccountMenuList, ToggleSideBar, removeSideBar } from "../MyAccountMenuList";
import { Link } from "react-router-dom";
import { vaultCardList } from "shared/settings/apiconfig";
import { PaymentServices } from "shared/services";
import '../../../../base/public/Items/ItemView.scss';
import moment from "moment/moment";
import authService from "shared/services/authService";
import '../../../../base/auth-pages/MyAccount/payment-methods/PaymentMethodsAdd.scss';
import { HeaderHOC } from "../headerHOC/HeaderHOC";

/* Shows the list of vaulted cards */
class PaymentMethodsList extends Component {

    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.config = {
            url: `${vaultCardList}`,
            params: {},
            columns: [
                { name: '', property: 'id', columnType: 'custom', customHeader: this.customAddButton(), width: '110px', customColumn: this.customDeleteButton },
                { name: 'Default Method', property: 'defaultmethod', width: '160px', columnType: 'custom', customColumn: this.customRadioButton },
                { name: 'Type', property: 'cardtype', width: '130px', columnType: 'custom', customColumn: this.customCardType },
                { name: 'PayPal Id/Card Ending with', property: 'cardlastfourdigit', width: '160px', columnType: 'custom', customColumn: this.customCardEndDigit },
                { name: 'Expiration Date', property: 'cardexpirydate', width: '180px' },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: 'Details', width: '75px',
                    accordion: this.accordionValue
                }
            ],
            sort: [{ field: 'isdefault', direction: 'desc' }],
            pagination: true,
            service: 'BUYER'
        };
        this.state = {
            isdefault: false,
            isdelete: false,
            defaultCardConfirmModal: false,
            removeCardConfirmModal: false,
            defaultCardId: '',
            deleteCardId: ''
        }
    }

    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        ToggleSideBar();
        window.addEventListener('resize', ToggleSideBar);
    }

    closeConfirmModal = () => {
        this.setState({
            defaultCardConfirmModal: false,
            removeCardConfirmModal: false,
            removeCardSuccessModal: false,
            cardExpired: false,
            cardGoingToExpire: false
        });
    }

    openConfirmModal = (data) => {
        this.setState({
            removeCardConfirmModal: true,
            deleteCardId: data.id,
            cardData: data
        })
    }

    openDefaultConfirmModal = (data) => {
        this.setState({
            defaultCardConfirmModal: true,
            defaultCardId: data.id,
            cardData: data
        })
        this.cardExpires(data);
    }

    cardExpires = (data) => {
        var currentDate = moment().utc();
        var expiryDate = moment.utc(data.cardexpirydate);
        var futureDate = moment().utc().add(30, "days").endOf('day');
        if(expiryDate.isBefore(currentDate)){
            this.setState({
                cardExpired: true
            })
        } else if(expiryDate.isBefore(futureDate)) {
            this.setState({
                cardGoingToExpire: true
            })
        } else {
            this.updateDefault(data);
        }
    }

    customAddButton = () => {
        return (
            <Link to="/my-account/my-info/payment-methods/add">
                <Button disabled={!this.props.user.profilecompleted} variant="secondary">Add Payment Method</Button>
            </Link>
        );
    };

    customDeleteButton = (values) => {
        return (
            <Button variant="danger" style={{ minWidth: "167px" }} onClick={()=>this.openConfirmModal(values)} disabled={this.state.isdelete || this.dataTable?.current?.state?.tableLoading}>Remove</Button>
        );
    };

    removeCard = () => {
        this.setState({
            isdelete: true
        })
        PaymentServices.deleteVaultCard({data: {"id": this.state.deleteCardId}}).then(data => {
            if(data.data.status == "success"){
                this.setState({
                    removeCardConfirmModal: false,
                    removeCardSuccessModal: true,
                    removeCardMessage: data.data.message
                })
                this.dataTable.current.getTableData();
                authService.getUserDetails(this.props.user.id).then((response) => {
                    store.dispatch({ type: 'SET_USER', payload: { ...this.props.user, paymentcompleted: response.data.data[0]['paymentcompleted'] }});
                });
            } 
            this.setState({
                isdelete: false
            })
        }).catch(error => {
            if (error.status === 503) {
                this.serviceDown();
            } else {
                if(error.status === 400) {
                    this.setState({
                        removeCardConfirmModal: false,
                        removeCardSuccessModal: true,
                        removeCardMessage: error.message
                    })
                }
            }
            this.setState({
                isdelete: false
            })
            return;
        });
    };

    customRadioButton = (values) => {
        return (
            <div className="default-radio">
                <input type="radio" className="radio-btn" aria-label="select default payment method" name="default" id={`inline-${values.id}`} checked={values['isdefault']} onChange={()=>{this.openDefaultConfirmModal(values)}} disabled={this.state.isdefault || this.dataTable?.current?.state?.tableLoading} />
            </div>
        );
    };

    updateDefault = (value) => {
        this.setState({
            isdefault: true,
        })
        PaymentServices.defaultVaultCard({data: {"id": value.id}}).then(data => {
            if(data.data.status == "success"){
                this.setState({
                    defaultCardConfirmModal: true,
                    defaultCardMessage: data.data.message
                })
                this.dataTable.current.getTableData();
            } 
            this.setState({
                isdefault: false
            })
        }).catch(error => {
            if (error.status === 503) {
                this.serviceDown();
            } else {
                if(error.status === 400) {
                    this.setState({
                        defaultCardConfirmModal: true,
                        defaultCardMessage: error.message
                    })
                }
            }
            this.setState({
                isdefault: false
            })
            return;
        });
    }

    customAddress = (values) => {
        const address = values;
        if (!address) return '- - -';

        return address.address_line_1 + ', ' + (address.address_line_2 ? address.address_line_2 + ", " : "") +
            address.admin_area_2 + ', ' + address.admin_area_1 + ' ' +
            address.postal_code + ', United States';
    };

    windowResizeHandle = () => {
        ToggleSideBar();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResizeHandle);
        removeSideBar();
    }

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div style={{ padding: "1% 2%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex" style={{ justifyContent: "space-evenly"}}>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Card Brand</div>
                            <div>{row['cardbrand']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Billing Address</div>
                            <div>{this.customAddress(JSON.parse(row['billingaddress']))}</div>
                        </div>
                    </div>
                    : ''}
            </div>
        );
    }

    customCardType = (values) => {
        if (values.cardtype.toLowerCase() == "unknown") {
            return "- - -";
        } else {
            return values.cardtype;
        }
    }

    customCardEndDigit = (values) => {
        if (values.paypalid) {
            return values.paypalid;
        } else if (values.cardlastfourdigit) {
            return values.cardlastfourdigit;
        } else {
            return "- - -";
        }
    }

    render() {
        return (
            <div className="overflow-auto top-border" style={{ padding: "20px 3rem" }}>
                <HeaderHOC {...this.props}/>

                <Datatable config={{ ...this.config }} ref={this.dataTable} />

                <Modal centered show={this.state.defaultCardConfirmModal} keyboard={false}>
                    <Modal.Body>
                        <div className="bid-confirmation">
                            <div className="header">
                                Default Card Confirmation
                            </div>
                            <div className="body-content">
                                <div className="placebid-bg" style={{textAlign: 'center'}}>
                                    {
                                        this.state.cardExpired ? 
                                        <p>
                                            The payment method you provided has expired. Please provide a new valid form of payment to continue bidding.
                                        </p> : 
                                        this.state.cardGoingToExpire ?
                                        <p>
                                            The payment method you have provided has going to expires soon. Please provide a new valid form of payment.
                                        </p> : 
                                        <p>
                                            {this.state.defaultCardMessage}
                                        </p>
                                    }    
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center actions">
                            <Button variant="secondary mx-2" onClick={() => this.closeConfirmModal()}>Close</Button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.removeCardConfirmModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="bid-confirmation">
                            <div className="header">
                                Remove Card Confirmation
                            </div>
                            <div className="body-content">
                                <div className="placebid-bg" style={{textAlign: 'center'}}>
                                    <p>
                                        Please note that a valid payment method is required to bid. Do you wish to proceed with deleting this payment method?
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center actions">
                            <div className="d-flex align-items-center justify-content-center actions">
                                <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>No</Button>
                                <Button variant="secondary mx-2" onClick={()=>this.removeCard()}>Yes</Button> 
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.removeCardSuccessModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="bid-confirmation">
                            <div className="header">
                                Remove Card Confirmation
                            </div>
                            <div className="body-content">
                                <div className="placebid-bg" style={{textAlign: 'center'}}>
                                    <p>
                                        {this.state.removeCardMessage}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center actions">
                            <div className="d-flex align-items-center justify-content-center actions">
                                <Button variant="secondary mx-2" onClick={() => this.closeConfirmModal()}>Ok</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(PaymentMethodsList);